<mat-action-list class="p-0">
  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" *ngFor="let nav of navigationList" [routerLink]="['/' + nav.route]" [routerLinkActive]="'active-page'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon [ngClass]="listItem.isActive ? 'material-icons-round' : 'material-icons-outlined'">{{nav.icon}}</mat-icon>
        <button>
            {{ nav.name | translate}}
        </button>
      </mat-list-item> -->

  <mat-list-item
    disableRipple
    style="margin-bottom: 5px !important"
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'dashboard']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">dashboard</mat-icon>
    <button>Dashboard</button>
  </mat-list-item>
  <div
    class="sdf_section selected"
    *ngFor="let item of businessListData"
    (click)="openBusinessDetails(item)"
    [ngClass]="{ selected1: isActive(item.hash_id) }"
  >
    <div class="side_img">
      <img
        [src]="item.default_image.image_thumb_url"
        onerror="this.src = '../../../../assets/images/entity_placeholder.png'"
        *ngIf="item.revenue_model == 1"
      />
      <img
        [src]="item.default_image.image_thumb_url"
        onerror="this.src = '../../../../assets/images/fitness-placeholder.png'"
        *ngIf="item.revenue_model == 2"
      />
    </div>
    <div class="side_textc">
      <h4 [ngClass]="{ 'make-text-white': isActive(item.hash_id) }">
        {{ item.name }}
      </h4>
      <p [ngClass]="{ 'make-text-white': isActive(item.hash_id) }">
        {{ item.address_line ? item.address_line : "No address Info" }}
      </p>
    </div>
  </div>
  <!-- <div class="sdf_section">
        <div class="side_img">
            <img src="https://naomisheadmasters.com/wp-content/uploads/2022/10/GettyImages-947995974-3.jpg">
        </div>
        <div class="side_textc">
          <h4>Javed spa</h4>
          <p>Bordoloi Nagar, Tinsukia, Assam, India</p>
        </div>
      </div> -->

      <mat-accordion class="dffrtr">
        <mat-expansion-panel [expanded]="panelState[0]"  (opened)="panelState[0] = true"
                             (closed)="panelState[0] = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="aa_paddf">
              <mat-icon mat-list-icon class="material-icons">calendar_month</mat-icon>
            </div>
             <span class="booking_ht"> Bookings / Queries</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'new-booking']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons">person_add</mat-icon>
            <button>
              New booking / query
            </button>
          </div>
          </mat-list-item>
           <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'enroll-new-member']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <!-- <mat-icon mat-list-icon class="material-icons">diversity_3</mat-icon> -->
             <mat-icon mat-list-icon class="material-icons">groups_2</mat-icon>
             
            <button>
              Enroll new member
            </button>
          </div>
          </mat-list-item>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'produce-bill']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons-outlined">post_add</mat-icon>
            <button>
              Produce bill / invoice
            </button>
          </div>
          </mat-list-item>
          <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-bookings']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
            <div class="bookingh_section">
            <mat-icon mat-list-icon class="material-icons">list</mat-icon>
            <button>
              All activity / queries
            </button>
          </div>
          </mat-list-item>
        </mat-expansion-panel>

      </mat-accordion>

  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden "    [ngClass]="{'active-item': isActive('bookings')}">
        <mat-icon mat-list-icon class="material-icons">calendar_month</mat-icon>
        <button>
          Bookings 
        </button>
      </mat-list-item>
      <div class="sed">
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'new-booking']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <div class="bookingh_section">
        <mat-icon mat-list-icon class="material-icons">person_add</mat-icon>
        <button>
          New booking
        </button>
      </div>
      </mat-list-item>
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'produce-bill']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <div class="bookingh_section">
        <mat-icon mat-list-icon class="material-icons-outlined">post_add</mat-icon>
        <button>
          Produce bill
        </button>
      </div>
      </mat-list-item>
      <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " [routerLink]="['/' + 'all-bookings']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <div class="bookingh_section">
        <mat-icon mat-list-icon class="material-icons">list</mat-icon>
        <button>
          All bookings
        </button>
      </div>
      </mat-list-item>
    </div> -->

  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'service-list']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons"
      >settings_applications</mat-icon
    >
    <button>Services / Packages</button>
  </mat-list-item>
  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'business-hours']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">hourglass_top</mat-icon>
    <button>Business hours</button>
  </mat-list-item>
  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'all-employees']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">badge</mat-icon>
    <button>Employees</button>
  </mat-list-item>
  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'all-customers']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">family_restroom</mat-icon>
    <button>Customers</button>
  </mat-list-item>
  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'all-members']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">groups_2</mat-icon>
    <button>Members</button>
  </mat-list-item>

  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden"  [routerLink]="['/' + 'my-recharges']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">payments</mat-icon>
        <button>
          Recharges 
        </button>
      </mat-list-item> -->

  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    [routerLink]="['/' + 'contact-us']"
    [routerLinkActive]="'active-item'"
    #listItem="routerLinkActive"
  >
    <mat-icon mat-list-icon class="material-icons">contact_page</mat-icon>
    <button>Contact us</button>
  </mat-list-item>
  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" [routerLink]="['/' + 'share-friends']" [routerLinkActive]="'active-item'" #listItem="routerLinkActive">
        <mat-icon mat-list-icon class="material-icons">share</mat-icon>
        <button>
          Refer a friend
        </button>
      </mat-list-item> -->
  <mat-list-item
    disableRipple
    class="mb-2 rounded-2 overflow-hidden"
    (click)="openLink('https://lookzup.com/help')"
  >
    <mat-icon mat-list-icon class="material-icons">help</mat-icon>
    <button>Help & Guide</button>
  </mat-list-item>

  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden" (click)="openLink('https://lookzup.medium.com')">
        <mat-icon mat-list-icon class="material-icons">article</mat-icon>
        <button >
          Blogs
        </button>
      </mat-list-item> -->

  <!-- <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " (click)="openprivacypolicy()" >
        <mat-icon mat-list-icon class="material-icons-outlined">lock</mat-icon>
        <button>
            {{ 'nav_links.privacy_policy' | translate}}
        </button>
      </mat-list-item>
    <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " (click)="opentos()">
        <mat-icon mat-list-icon class="material-icons-outlined">description</mat-icon>
        <button>
            {{ 'nav_links.terms_of_service' | translate}}
        </button>
      </mat-list-item>
    <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " (click)="opendownloadapp()">
        <mat-icon mat-list-icon class="material-icons-outlined">download</mat-icon>
        <button>
            {{ 'nav_links.invite_friends' | translate}}
        </button>
      </mat-list-item>
  <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden " (click)="inviteFriends()">
        <mat-icon mat-list-icon class="material-icons-outlined">share</mat-icon>
        <button>
            {{ 'nav_links.share' | translate}}
        </button>
      </mat-list-item> -->
  <mat-list-item disableRipple class="mb-2 rounded-2 overflow-hidden">
    <mat-icon mat-list-icon class="material-icons-outlined">ballot</mat-icon>
    <button>{{ "nav_links.version" | translate }} {{ version }}</button>
  </mat-list-item>
</mat-action-list>
